export const MARKET_NAME = { pts: "Points", reb: "Rebounds", ast: "Assists", fg3m: "3 Pointers", pra: "Pts + Reb + Ast" };
// Bookmaker milestones: '20+' is stored as over 19.5.
export const milestone = (line) => (line % 1 === 0.5 ? line + 0.5 : line);
export const msLabel = (r) => (r.variant === "line" ? `O/U ${r.line}` : `${milestone(r.line)}+`);
export const LADDER = {
  pts: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50], reb: [2, 4, 6, 8, 10, 12, 14, 16], ast: [2, 4, 6, 8, 10, 12, 14],
  fg3m: [1, 2, 3, 4, 5, 6, 7, 8], pra: [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60],
};
export const BOOK_COLOR = { Bet365: "#0f7b4b", DraftKings: "#53a318", FanDuel: "#1a6dff", Assos365: "#c9302c", Stoiximan: "#f26b21" };
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const gameLabel = (g) => (g ? `${g.away_code} @ ${g.home_code}` : "—");
export const rowState = (r) => {
  const sides = [r.over, r.under].filter(Boolean);
  if (!sides.length) return "none";
  return sides.some((d) => d.check && !d.result) ? "pending" : "verified";
};

// One row per player / bookmaker / milestone with its over and under price; missing ladder steps for one player as "No odds".
export function buildRows(lines, { game, player, book, market }) {
  const rows = {};
  lines.filter((l) => l.game_id === game && l.market === market && (!player || l.player_id === player) && (!book || l.bookmaker === book))
    .forEach((l) => {
      const key = `${l.player_id}|${l.bookmaker}|${l.variant}|${l.line}`;
      rows[key] = { key, player_id: l.player_id, player_name: l.player_name, team: l.team, bookmaker: l.bookmaker, variant: l.variant, line: l.line, ...rows[key], [l.side]: l };
    });
  const out = Object.values(rows);
  if (player) {
    const have = new Set(out.filter((r) => r.variant !== "line").map((r) => milestone(r.line)));
    (LADDER[market] || []).filter((m) => !have.has(m)).forEach((m) => out.push({ key: `none|${m}`, player_id: player, variant: "milestone", line: m - 0.5, empty: true }));
  }
  return out;
}

export const SORTS = {
  asc: (a, b) => a.line - b.line || (a.player_name || "").localeCompare(b.player_name || ""),
  desc: (a, b) => b.line - a.line || (a.player_name || "").localeCompare(b.player_name || ""),
  player: (a, b) => (a.player_name || "").localeCompare(b.player_name || "") || a.line - b.line,
  latest: (a, b) => ((b.over || b.under)?.scanned_at || "").localeCompare((a.over || a.under)?.scanned_at || ""),
};

export function shotsFor(shots, { game, market, book, player }) {
  return shots.filter((s) => ((s.game_ids || []).includes(game) || (!s.game_ids?.length && s.game_hint === game))
    && (!book || s.bookmaker === book)
    && (!market || !s.ranges?.length || s.ranges.some((r) => r.market === market && (!player || r.players.includes(player)))));
}
